
import React from 'react';
import LoginPage from "../pages/LoginPage";
import CallAssistant from "../pages/CallAssistant";
import ForgottenPasswordPage from "../pages/ForgottenPasswordPage";
import Constants from "../constants/text-constants";

const routes = [
    {
        path: '/login',
        exact: true,
        component: <LoginPage />,
        pageTitle: Constants.SIGN_IN_TITLE,
    },
    {
        path: '/forgotten-password',
        exact: true,
        component: <ForgottenPasswordPage />,
        pageTitle: Constants.FORGOT_PASSWORD_TITLE,
    },
    {
        path: '/call-assistant',
        exact: true,
        component: <CallAssistant />,
        pageTitle: Constants.CALL_ASSISTANT_TITLE,
    }
]

export default routes;
